import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink, ITranslations } from "@/types"
import { getTranslation } from "utils/translations"

export interface IGetDeliveryTermDto {
    id: Guid
    termId: string
    termDescription: ITranslations
    links?: IApiLink[] | null
}

export interface ICreateUpdateDeliveryTermDto {
    termId: string
    termDescription: ITranslations
}

export default class DeliveryTerm {
    id: Guid
    termId: string
    termDescription: ITranslations

    linkGet?: IApiLink
    linkUpdate?: IApiLink

    constructor(dto: IGetDeliveryTermDto) {
        this.id = dto.id
        this.termId = dto.termId
        this.termDescription = dto.termDescription

        this.linkGet = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsDeliveryTerms && lnk.rel === ApiLinkRel.self)
        this.linkUpdate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsDeliveryTerms && lnk.rel === ApiLinkRel.update)
    }

    toDto(): IGetDeliveryTermDto {
        return {
            id: this.id,
            termId: this.termId,
            termDescription: this.termDescription,
        }
    }

    print() {
        return getTranslation(this.termDescription)
    }
}
